import React, { useEffect, useState, useContext } from "react";
import { Form, Input, Select, Space, Row, Col, Card, Button, Modal, Table, message, Popconfirm,Tooltip } from "antd";
import { EditOutlined, DeleteOutlined,ProfileFilled,UserOutlined } from "@ant-design/icons";
import "../components/FirmPartner/Firmpartner.css";
import { UserContext } from "../App";
import "../Styles/subtenant.css";
import Services from "../network/Services";
import konsole from "../network/konsole";
import DeleteConfirmModal from "./DeleteConfirmModal";
import InputMask from "./PhoneInputMask";
import { isValidFuntion } from "../control/Constant";
import commonLib from "../control/commonLib";
const Academy = () => {
    const [number, setNumber] = useState(1);
    const [addUser, setAddUser] = useState(false)
    const [countrycode, setcountryCode] = useState([]);
    const [countryCodeValue, setcountryCodeValue] = useState()
    const [data, setdata] = useState([]);
    const [visible, setVisible] = useState(false);
    const [subtenantValue, setSubtenantValue] = useState('');
    const [subtenantdata, setsubtenantdata] = useState([]);
    const [createAccademyUser, setCreateAccademyUser] = useState()
    const [show, setshow] = useState(false)
    const [selectedSubtenant, setselectedSubtenant] = useState('')
    const { setLoader } = useContext(UserContext)
    const [roleid, setroleid] = useState('')
    const [defaultvalue, setDefaultvalue] = useState('Select a partner')
    const [disabledselect, setdisableselect] = useState(false)
    const [searchevent, setSearchevent] = useState("");
    const [form] = Form.useForm();
    const [upGradeUserData, setupGradeUserData] = useState()
    const [updatePartnerUsersData, setUpdatePartnerUsersData] = useState()
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const { Option } = Select;
    const createdBy = null;
    const isActive = true;
    const [deleteModal, setDeleteModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    // paginated data
    const paginatedData = (data) => {
        const start = (currentPage - 1) * pageSize;
        return data?.slice(start, start + pageSize);
    };



    useEffect(() => {
        if (deleteModal == true) {
            showRolesModalFunc()
        }
        if (addUser == true) {

        }
    }, [deleteModal, createAccademyUser])
    const showUserModal = () => {
        setUpdatePartnerUsersData()
        setVisible(true);
        setshow(!show);
    };
    const onChangePhone = (value) => {
        form.setFieldsValue({
            mobile: value,
        });
    };
    useEffect(() => {

        const countryCode = Services.getcountrycode();
        countryCode
            .then((response) => {
                setcountryCode(response.data.data);
            })
            .catch((err) => {
                konsole.log("Error", err);
            });
    }, []);

    const showRolesModalFunc = () => {
        setShowDeleteModal(false)
        let promis = Services.getExpirydatetime(upGradeUserData?.userRgstrtnId)
        promis.then((response) => {
            let data = response?.data?.data
            const originalDate = new Date();
            originalDate.setFullYear(originalDate.getFullYear() + 1);
            let createdBy = sessionStorage.getItem('loggedUserId')
            upGradeValidityPeriod(data?.userValidityId, data?.loginUserid, data?.userId, data?.userRoleId, data?.roleId, originalDate, createdBy, true)
        }).catch((err) => {

        })
    };
    const upGradeValidityPeriod = (userValidityId, loginUserid, userId, userRoleId, roleId, expriedDate, createdBy, isCash) => {
        setLoader(true)
        let promises = Services.putUpgradeValidity(userValidityId, loginUserid, userId, userRoleId, roleId, expriedDate, createdBy, isCash);
        promises
            .then(function (response) {
                setLoader(false)
                updateAcademy()
            })
            .catch((err) => {
                setLoader(false);
            });

    }
    const updateAcademy = async () => {
        setLoader(true)
        const userPrimaryDetail = upGradeUserData?.primaryEmail
        await Services.apiCallScripePaymentConfirmation({ userEmail: userPrimaryDetail })
        setShowDeleteModal(false)
        setDeleteModal(false)
        getUserListApi()
        message.success('Upgrade Successfully')
        setLoader(false)
    }

    const hideUserModal = () => {
        setVisible(false);
        setshow(false)
    };

    const onFinish = (values) => {
        konsole.log("Finish:", values);
    };
    useEffect(() => {
        getUserListApi();
    }, [subtenantValue]);
    useEffect(() => {
        let userroleId = JSON.parse(sessionStorage.getItem("stateObj"))
        let subtenantId = sessionStorage.getItem("subtenantId")
        setroleid(userroleId?.roleId)
        if (isValidFuntion(subtenantdata) && roleid == "11") {
            setdisableselect(true)
            setSubtenantValue(subtenantId);
            setselectedSubtenant(subtenantId)
            let datafilter = subtenantdata.filter((val) => {
                return val.subtenantId == subtenantId
            })
            if(datafilter.length > 0){
                setDefaultvalue(datafilter[0]?.subtenantName)
                setselectedSubtenant(datafilter[0]?.subtenantName)
                konsole.log("datafilterdatafilter", datafilter)
            }


        } else {
            if (subtenantdata.length > 0) {
                const { subtenantName, subtenantId } = subtenantdata[0];
                setDefaultvalue(subtenantName);
                setSubtenantValue(subtenantId);
                setselectedSubtenant(subtenantName);
            }

            setdisableselect(false)
        }

    }, [subtenantdata])

    useEffect(() => {
        const Subtenantdetailspromise = Services.getsubtenantdetails(
            createdBy,
            isActive
        );
        Subtenantdetailspromise.then((res) => {
            setsubtenantdata(res.data.data);
        }).catch((err) => {
            konsole.log("err", err);
        });
    }, []);

    const getUserListApi = (startValue, EndValue) => {
        if (startValue !== 1) {
            setLoader(true)
        }
        const subtenantId = subtenantValue;
        if (subtenantId !== '' && subtenantId !== undefined && subtenantId !== null) {

            const getUserlistpromise = Services.getUserListByRoleIdAcadmy(3, true, "AOACADEMY");
            getUserlistpromise.then((res) => {
                setdata(res.data.data);
                form.setFieldsValue({
                    fName:"",
                    lName:"",
                    number:"(+1) USA",
                    mobile:"",
                    email:""
                })
                // setAssignOptionsList(res.data.data);
                setLoader(false)

            })
                .catch((err) => {
                    konsole.log("errerr", err);
                }).finally(() => {
                    setLoader(false);
                });
        }
    };
    const onSearch = (value) => konsole.log(value);

    const searchonchange = () => {
        let filteredData = [];
        if (searchevent !== null && searchevent !== '' && searchevent !== undefined) {
            let filter = data?.filter((items) => {
                let name = items?.fullName
                let userName = items?.userName
                return name.toLowerCase().includes(searchevent.toLocaleLowerCase()) ||
                    userName.toLowerCase().includes(searchevent.toLocaleLowerCase())
            })
            filteredData = filter
        } else {
            filteredData = data
        }

        return filteredData
    }
    const filteredData = searchonchange();
    const totalPages = Math.ceil(filteredData.length / pageSize);
    const paginatedRows = paginatedData(filteredData);



    const upGrade = (data) => {
        setupGradeUserData(data)
        setShowDeleteModal(true)
    }

    const updatePartnerUsers = (datas) => {
        setUpdatePartnerUsersData(datas)
        setVisible(true);
        setshow(!show)


    }
    const onClickRow = (data) => {
        //   showModal(true)
        //   setuserdata(data)
    }

    const confirm = (data) => {
        setLoader(true)

        let createdBy = sessionStorage.getItem('loggedUserId')
        konsole.log("aaaaaaWorking", createdBy)

        let promise = Services.postSendUserActivationLink(data?.subtenantId, data?.userRgstrtnId, data?.userId, data?.fullName, data?.primaryEmail, data?.userRgstrtnId, createdBy, "::1")
        promise.then((response) => {
            konsole.log("postSendUserActivationLinkres", response)
            setLoader(false)
            message.success('Link Send Successfully')
        }).catch((error) => {
            konsole.log("postSendUserActivationLinkerror", error)
            setLoader(false)
        }).finally(() => {
            setLoader(false)
        })



    }
    const onFinishForm = (data) => {
        setCreateAccademyUser(data)
        setAddUser(true)


    };
    const callAddUserApi = (data) => {
        setAddUser(false)
        const formdata = form.getFieldsValue();
        setLoader(true)
        const {fName,lName,email,number,mobile} = data
        let countryCode = number == undefined || number == null || number == "" ? "+1" : number

        let jsonObjData =
        {
            "subtenantid": 3,
            "signupplateform": 14,
            "user":
            {
                "roleid": 18,
                "firstname": fName,
                "lastname": lName,
                "emailaddress": email,
                "username": email,
                "countryCode": countryCode,
                "mobileNumber": mobile,
                "packageCode": "PREMIUMUSER300CASH"
            }
        }
        let postAddUserApiCall = Services.postAcademyUserdata(jsonObjData)
        postAddUserApiCall.then((res) => {
            setLoader(false)
            setVisible(false)
            getUserListApi()
            message.success('Registration Successfully')

        }).catch((error) => {
            if (error.response.data.messages.length > 0 && error.response.data.messages[0] == "ALREADY_REGISTERED") {
                message.error(error.response.data.messages[1])
            }
            setLoader(false)
        }).finally(() => {
            setLoader(false)
        })
    };
    const handleChange = (value) => {
        setcountryCodeValue(value);

    };

    function Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
    }
    const addUserAcademy = (data) => {
        if (data == true) {
            callAddUserApi(createAccademyUser)
        } else {
            setAddUser(false)
        }

    }
  const dtHeaderStyle = { color: '#333', fontWeight: 600,fontSize: '14px', background: '#fff',textAlign: 'start',padding:"8px" }
  const dtBodyStyle =  { color: '#333',fontSize: '13px', background: '',textAlign: 'start' ,fontWeight: 100,padding:"8px",cursor:"pointer"}
  const dtBodyStyle2 = { color: '#333',fontSize: '13px', background: '',textAlign: 'center',fontWeight: 100,display:"contents",padding:"8px" }
    return (
        <>
            <div className="row d-flex justify-content-between" style={{ width: "100.5%", }}>
                <div className="col-12 d-flex " style={{ paddingTop: "8px",borderBottom:"1px solid #474747"}} >
                    {/* <button className="schedule-active me-2 schedule"
                    >Academy Users</button> */}
                </div>
                <div style={{ paddingRight: "0px", }}>
                    {number == 1 ? (
                        <>
                            <div className="d-flex flex-column">
                                <Form.Provider
                                    onFormFinish={(name, { values, forms }) => {
                                        if (name === "userForm") {
                                            const { basicForm } = forms;
                                            setVisible(false);
                                        }
                                    }}
                                    className="me-4">
                                    <Form name="basicForm" onFinish={onFinish}>
                                        <div className="select-container"></div>
                                        <Row className="mt-3">
                                            <Col xs={24} lg={24} span={24} style={{ display: "flex", justifyContent: "space-between" }}>
                                                <Col span={12} style={{ display: "flex" }}>

                                                    {/* <div className="w-100 d-flex" style={{ border: "2px solid lightgray", borderRadius: "5px", justifyContent: "space-between", height: "39px" }}>
                                                        <img style={{ padding: "2px", height: "20px", marginTop: "8px", marginRight: "4px" }} src="/search icon.png" />
                                                        <input className="form-control fs-20" style={{ border: "none" }} type="text" placeholder="Search for Academy User" onChange={(e) => setSearchevent(e.target.value.toLowerCase())} />
                                                    </div> */}
                                                    <div style={{ flex: 2, minWidth: '180px', display: 'flex', border: '1px solid #333', borderRadius: '5px', height: '44px', alignItems: 'center' }}>
                                                        <img style={{ padding: '2px', height: '20px', marginRight: '4px', marginLeft: '4px' }} src="/search icon.png" />
                                                        <input
                                                            className="form-control newInput searchBox"
                                                            style={{ border: 'none', outline: 'none', flex: 1, height: '100%', borderRadius: '5px' }}
                                                            type="text"
                                                            placeholder={'Search for Academy User'}
                                                            // onChange={(e) => setSearchevent(e.target.value.toLowerCase())}
                                                            onChange={(e) => {
                                                                setSearchevent(e.target.value.toLowerCase());
                                                                setCurrentPage(1);
                                                            }}
                                                        />
                                                    </div>
                                                    </Col>
                                                <Col>
                                                    <Button
                                                        htmlType="button"
                                                        style={{
                                                            // margin: "0 8px",
                                                            // backgroundColor: "#720c20",
                                                            // color: "white",
                                                            // borderRadius: "5px",
                                                            fontWeight: "600"
                                                            , height: "40px"
                                                        }}
                                                        className="add-user-btn"
                                                        onClick={showUserModal}
                                                    >
                                                        <span style={{ fontFamily: "sans-serif" }}>
                                                            {" "}
                                                            + ADD NEW ACADEMY USER
                                                        </span>
                                                    </Button>
                                                </Col>
                                            </Col>

                                            {(showDeleteModal || addUser) && (
                                                <DeleteConfirmModal
                                                    visible={showDeleteModal || addUser}
                                                    hideModal={showDeleteModal ? setShowDeleteModal : setAddUser}
                                                    titleText={showDeleteModal ? "Upgrade User" : "Create Academy User"}
                                                    bodyContent="Did you receive $300 in cash from this user for Premium Access to AgingOptions Academy ?"
                                                    deleteStatus={showDeleteModal ? setDeleteModal : addUserAcademy}
                                                />
                                            )}

                                        </Row>
                                    </Form>
                                </Form.Provider>

                                {/* <Table
                                    dataSource={searchonchange(data)}
                                    pagination={false}
                                    className=" mt-3 flex-grow-1 subtanantTable"
                                    scroll={{ y: 'calc(100vh - 250px)' }}


                                >
                                    <Row
                                        title="Name"
                                        className="manage fw-bold p-3  shadow-sm"
                                        dataIndex="fullName"
                                        key="fullName"
                                        render={(_, record) => (
                                            <a
                                                onClick={() => updatePartnerUsers(record)}
                                            >
                                                {record.fullName}
                                            </a>
                                        )}
                                    />
                                    <Row
                                        title="Start Date"
                                        className="manage fw-bold p-3  shadow-sm"
                                        dataIndex="startDate"
                                        key="startDate"
                                        render={(_, record) => (
                                            <a>
                                                {record?.startDate && commonLib.getFormattedDate(record.startDate)}
                                            </a>
                                        )}
                                    />
                                    <Row
                                        title="Expire Date"
                                        className="manage fw-bold  p-2 border-top-0 border-buttom-0 border-start-0 shadow-sm text-center border-gray"
                                        dataIndex="expriedDate"
                                        key="expriedDate"
                                        render={(_, record) => (<a>{record?.expriedDate && commonLib.getFormattedDate(record.expriedDate)} </a>)}
                                    />
                                    <Row
                                        title="Email"
                                        className="manage fw-bold p-2 shadow-sm text-center "
                                        dataIndex="primaryEmail"
                                        key="primaryEmail"
                                    />
                                    <Row
                                        title="Status"
                                        className="manage fw-bold p-2 shadow-sm "
                                        dataIndex="isActive"
                                        key="isActive"
                                        render={(_, record) => (

                                            <p>
                                                {record.isActive ?
                                                    <><p style={{ color: "green", marginTop: "18px" }}>Active</p></> :
                                                    <>
                                                        <Popconfirm
                                                            title=" "
                                                            okText={`Resend Activation Link`}
                                                            icon={false}
                                                            showCancel={false}
                                                            onConfirm={() => confirm(record)}>
                                                            <a><p style={{ color: "orange", cursor: "pointer", marginTop: "18px" }}>Inactive</p></a>
                                                        </Popconfirm>
                                                    </>
                                                }
                                            </p>
                                        )}
                                    />

                                    <Row
                                        className="manage fw-bold  shadow-sm "
                                        gutter={[8, 8]}
                                        title="Action"
                                        key="action"
                                        render={(_, record) => (
                                            <Col xs={24} className="d-flex justify-content-center gap-5">

                                                {record?.academyUserType == "TRIAL USER" ?
                                                    <a className="text-center text-decoration-none text-black" style={{ marginLeft: "5px" }} onClick={() => upGrade(record)}>
                                                        {" "}<img src="/images/vector.png"></img><br />Upgrade User
                                                    </a> : <a>{record.academyUserType}</a>}

                                            </Col>
                                        )}
                                        style={{ width: "10px" }}
                                    />
                                </Table> */}

                                <div style={{ border: '1px solid #ddd', marginTop: '12px' }}>
                                    <div style={{ maxHeight: 'calc(100vh - 200px)'}}>
                                        <table className="table table-bordered mb-0 staff-table custom-striped-table" style={{ fontFamily: "Open Sans, sans-serif", fontSize: '13px' }}>
                                            <thead style={{ position: 'sticky', top: -1, zIndex: 1, background: '#fff' }}>
                                                <tr>
                                                    <th style={dtHeaderStyle}>Name</th>
                                                    <th style={dtHeaderStyle}>Start Date</th>
                                                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }}>Expire Date</th>
                                                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }}>Email</th>
                                                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }}>Status</th>
                                                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paginatedRows?.length > 0 ? paginatedRows?.map((record) => (
                                                    <tr key={record.userId}>
                                                         <Tooltip title="Click to activate or deactivate staff">
                                                        <td style={dtBodyStyle}   onClick={() => updatePartnerUsers(record)}>{record?.fullName}</td>
                                                         </Tooltip>
                                                        <td style={dtBodyStyle}>{record?.startDate && commonLib.getFormattedDate(record?.startDate) || '-'}</td>
                                                        <td style={dtBodyStyle}>{record?.expriedDate && commonLib.getFormattedDate(record?.expriedDate) || '-'}</td>
                                                        <td style={dtBodyStyle}>{record?.primaryEmail}</td>

                                                         {record.isActive ? (
                                                        // <td style={dtBodyStyle}>
                                                        //   <span style={{ color: 'green', cursor: 'pointer', fontWeight: 500, display: "contents" }}>Active</span>
                                                         // </td>
                                                            <td style={dtBodyStyle}>      
                                                            <span
                                                            style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', cursor: 'pointer', border: '1.5px solid #52c41a', borderRadius: '6px', padding: '2px 10px', background: '#F3F8F5', color: '#15803D', fontWeight: 500, fontSize: '12px', whiteSpace: 'nowrap', minWidth:"80px"}}>
                                                            <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#15803D', display: 'inline-block', flexShrink: 0 }} />
                                                            Active
                                                            </span>
                                                        </td>

                                                    ) : (

                                                    // <td style={dtBodyStyle}>
                                                    //     <span style={{ color: 'orange', cursor: 'pointer', fontWeight: 500, display: "contents" }}>Inactive</span>
                                                    // </td>
                                                    <td style={dtBodyStyle}>
                                                    <span
                                                    style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', cursor: 'pointer', border: '1.5px solid #adb5bd', borderRadius: '6px', padding: '2px 10px', background: '#f1f3f5', color: '#495260', fontWeight: 500, fontSize: '12px', whiteSpace: 'nowrap', minWidth:"80px"}}>
                                                    <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#495260', display: 'inline-block', flexShrink: 0 }} />
                                                    Inactive
                                                    </span>
                                                </td>
                                            )}
                                            <td style={dtBodyStyle}>{record?.academyUserType}</td>
                                                    </tr>
                                                )) : (
                                                    <tr><td colSpan={6} style={{ textAlign: 'center', padding: '20px', color: '#777' }}>No matching records found.</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '10px 16px',
                                            borderTop: '1px solid #ddd',
                                            background: '#fff'
                                        }}
                                    >
                                        <span style={{ fontSize: '13px', color: '#555' }}>
                                            Showing {Math.min((currentPage - 1) * pageSize + 1, filteredData.length)}
                                            {' '}to{' '}
                                            {Math.min(currentPage * pageSize, filteredData.length)}
                                            {' '}of {filteredData.length} entries
                                        </span>

                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}
                                        >

                                            <button
                                                onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                                                disabled={currentPage === 1}
                                                style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    background: '#fff',
                                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                                    color: '#555'
                                                }}
                                            >
                                                ‹
                                            </button>

                                            {(() => {
                                                const pages = [];

                                                for (let p = 1; p <= totalPages; p++) {
                                                    if (
                                                        p === 1 ||
                                                        p === totalPages ||
                                                        (p >= currentPage - 1 && p <= currentPage + 1)
                                                    ) {
                                                        pages.push(p);
                                                    }
                                                }

                                                const result = [];

                                                pages.forEach((p, i) => {
                                                    if (i > 0 && p - pages[i - 1] > 1) {
                                                        result.push(`ellipsis-${p}`);
                                                    }
                                                    result.push(p);
                                                });

                                                return result.map(item =>
                                                    typeof item === 'string' ? (
                                                        <span
                                                            key={item}
                                                            style={{
                                                                padding: '0 4px',
                                                                fontSize: '13px'
                                                            }}
                                                        >
                                                            ...
                                                        </span>
                                                    ) : (
                                                        <button
                                                            key={item}
                                                            onClick={() => setCurrentPage(item)}
                                                            style={{
                                                                width: '28px',
                                                                height: '28px',
                                                                border: '1px solid #ddd',
                                                                borderRadius: '4px',
                                                                background:
                                                                    currentPage === item
                                                                        ? '#720c20'
                                                                        : '#fff',
                                                                color:
                                                                    currentPage === item
                                                                        ? '#fff'
                                                                        : '#555',
                                                                cursor: 'pointer',
                                                                fontSize: '13px'
                                                            }}
                                                        >
                                                            {item}
                                                        </button>
                                                    )
                                                );
                                            })()}

                                            <button
                                                onClick={() =>
                                                    setCurrentPage(p =>
                                                        Math.min(p + 1, totalPages)
                                                    )
                                                }
                                                disabled={currentPage === totalPages}
                                                style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    background: '#fff',
                                                    cursor:
                                                        currentPage === totalPages
                                                            ? 'not-allowed'
                                                            : 'pointer',
                                                    color: '#555'
                                                }}
                                            >
                                                ›
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                </div>
            </div>
            {show && <>
                <Modal
                    visible={visible}
                    okText="Add"
                    onCancel={hideUserModal}
                    footer={null}
                    closable={true}
                    centered={true}
                    maskClosable={false}
                    enforceFocus={false}
                    width={1000}
                    style={{ top: 20 }}
                    bodyStyle={{ padding: '14px', maxHeight: 'calc(100vh - 80px)', overflowY: 'auto', borderRadius: '8px' }}>
                    <Form
                        initialValues={{ number: "(+1) USA",}}
                        form={form}
                        name="AdduserForm"
                        style={{ width: "100%", paddingRight: "5px", maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}
                        wrapperCol={{ span: 24 }}
                        labelCol={{ span: 0 }}
                        className="w-100"
                        layout="inline"
                        onFinish={onFinishForm}>

                        <div className="w-100">
                            <p className="fw-bolder mb-0 mt-2" style={{ color: "#333333", fontSize:"18px" }} >User Information</p>
                            <div style={{ borderBottom: "1px solid #BFBFBF", marginBottom: "24px", marginTop: "19px" }} />
                            <Card className="w-100" style={{ border: "1px dashed black", borderRadius: "5px", marginBottom:"19px" }}>
                                    <Row gutter={[16, 8]}>
                                        <Col xs={24} lg={12}>
                                            <Form.Item name="fName" style={{ marginBottom: 0 }} onSearch={Capitalize("")}
                                                rules={[{ required: true, message: "Please input your First Name!", },
                                                { pattern: /^[a-zA-Z\d\s]+$/, message: "Please input Valid First Name!", },]}
                                            >
                                                <Input placeholder="First Name" onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} lg={12}>
                                            <Form.Item
                                                name="lName"
                                                className="mt-1"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Please input your Last Name!",
                                                    },

                                                    {
                                                        pattern: /^[a-zA-Z\d\s]+$/,
                                                        message: "Please input Valid Last Name!",
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="Last Name" onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} lg={12}>
                                            <Form.Item
                                                name="email"
                                                style={{ marginBottom: 0 }}
                                                rules={[{ type: "email", required: true, message: "Please enter your E-mail" }]}
                                            >
                                                <Input placeholder="Email" disabled={(updatePartnerUsersData !== undefined && updatePartnerUsersData !== null && updatePartnerUsersData !== "") ? true : false} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} lg={12}>
                                            <div style={{ display: "flex", borderRadius: "4px" }}>
                                            <Form.Item
                                                name="number"
                                                    style={{ marginBottom: 0, flexShrink: 0 }}
                                                    rules={[{
                                                        required: true,
                                                        validator: (_, value) => {
                                                          if (value === "(+1) USA") return Promise.reject("Please select your country code");
                                                          return Promise.resolve();
                                                        },
                                                      }]}
                                            >
                                                    <Select
                                                    placeholder="Code"
                                                    optionFilterProp="children"
                                                    onChange={handleChange}
                                                    onSearch={onSearch}
                                                    style={{ width: "120px" }}
                                                    filterOption={(input, option) =>
                                                        option.children
                                                            .toLowerCase()
                                                            .includes(input.toLowerCase())
                                                    }
                                                    defaultValue={"(+1) USA"}
                                                >
                                                    {countrycode.map((countryProp) =>
                                                    (
                                                        <Option value={countryProp?.value}>
                                                            {countryProp?.label}

                                                        </Option>
                                                    ))}
                                                </Select>

                                            </Form.Item>
                                                <div style={{ width: "1px", background: "#d9d9d9", alignSelf: "stretch" }} />
                                            <Form.Item
                                                name="mobile"
                                                    style={{ marginBottom: 0, flex: 1 }}
                                                rules={[
                                                        { required: true, message: "Please enter your number" },
                                                        { pattern: /^[0-9]+$/, message: "Please input valid Cell number" },
                                                        { pattern: /^[\d]{0,10}$/, message: "Value should be less than 10 character" },
                                                    ]}>
                                                    <InputMask value={form.getFieldsValue().mobile} onValueChange={onChangePhone} style={{ border: "none", outline: "none", width: "100%", height: "100%", padding: "0 8px" }} />
                                            </Form.Item>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </div>

                        <Row className="mt-3 w-100" style={{ borderTop: "1px solid #BFBFBF", paddingTop: "24px" }}>
                            <Col className="w-100 d-flex justify-content-between">
                                <Button
                                    className="fw-bold"
                                    onClick={hideUserModal}
                                    style={{color: "#720C20",borderColor: "#720C20",borderRadius: 5, height:"44px", minWidth:"90px"}}>
                                    Cancel
                                </Button>
                                <Button
                                    className="fw-bold"
                                    htmlType="submit"
                                    style={{background: "#720C20",color: "white",borderRadius: 5, height:"44px", minWidth:"90px"}}>
                                   Save
                                    </Button>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </>}
        </>
    )
}

export default Academy